import { configMap } from '@organization/config'
import { useSessionContext } from '@shared/hooks'
import { AppConfig } from '@shared/types'
import { useLocation } from 'react-router-dom'

export const useAppConfig = () => {
  const { broker } = useSessionContext()
  const { pathname } = useLocation()
  const segments = pathname.split('/').filter(Boolean)

  const forceAppKey = broker ? 'insurance' : undefined

  const appSegment = segments[1]
  const appKey =
    forceAppKey || Object.keys(configMap).find((key) => key === appSegment)

  const allConfigs = Object.entries(configMap).reduce(
    (acc, [key, configFn]) => {
      acc[key] = configFn()
      return acc
    },
    {} as Record<string, AppConfig>
  )

  return appKey ? allConfigs[appKey] : configMap.default()
}
